export const usersPath = {
  /* inject path */
  USER_ACTIVTIES: '/users/user-activties',
  EDIT_PERMISSION_GROUP: '/users/edit-permission-group/:id',
  EDIT_PERMISSION_GROUP_URI: '/users/edit-permission-group',
  USER_PROFILE: '/users/user-profile/:id?',
  USER_PROFILE_URI: '/users/user-profile',
  ADD_NEW_PERMISSION_GROUP: '/users/add-new-permission-group',
  PERMISSION_GROUPS: '/users/permission-groups',
  ADD_NEW_USER: '/users/add-new-user',
  EDIT_USER: '/users/edit-user/:id',
  EDIT_USER_URI: '/users/edit-user',
  EDIT_PROFILE: '/users/edit-profile',
  DASHBOARD: '/users/dashboard',
  USERS_TABLE: '/users/users-table',
  RELEASE_NOTES: '/users/release-notes',
  RELEASE_NOTES_DETAILS: '/users/release-notes-details/:id',
  RELEASE_NOTES_DETAILS_URL: '/users/release-notes-details',
};
